import { Component, OnInit, Input, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Chart, ChartType, ChartOptions } from 'chart.js';
import { Label, SingleDataSet } from 'ng2-charts';
import { FormBuilder } from '@angular/forms';
import { GlobalService } from '../service/global.service';
import { LookupInfo } from '../model/lookup.model';
import { environment } from 'src/environments/environment';
import { SaleTeamInfo, SaleTeamManagementsInfo } from '../model/SaleTeamInfo.model';
import { TeamInfo } from '../model/team.model';
import { J } from '@angular/cdk/keycodes';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenService } from '../service/token.service';

@Component({
  selector: 'app-dashboard-sale',
  templateUrl: './dashboard-sale.component.html',
  styleUrls: ['./dashboard-sale.component.css']
})
export class DashboardSaleComponent implements OnInit {
  /******************************* Variables ********************************/
  baseurl: string;
  _EmpCode: string;
  _RoleCode: string;
  _ParamTeamCode: string;
  _ParamCurrentMonth: string;
  _ParamCurrentYear: string;

  ListColor: string[] = ['#20A2C0', '#44BA94', '#8AC541', '#7079B3', '#3763A8'];
  ListMonth: any = [];
  ListYear: number[] = [];

  CurrentYear: number;
  CurrentMonth: string;

  ddlProjectType: string = "";
  ddlMonth: string = "";
  ddlYear: string = "";

  TotalBudget: number;
  SaleTeams: TeamInfo[] = [];
  ListSaleTeamDetails: SaleTeamManagementsInfo[];
  ListTeamRank: TeamInfo[] = [];

  //Pie chart
  public pieChartLabels: Label[] = [];
  public pieChartData: SingleDataSet = [];
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = false;
  public pieChartPlugins = [];
  public pieChartColors = [
    {
      backgroundColor: [],
    },
  ];
  public pieChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      position: 'top'
    },
    maintainAspectRatio: false
  };

  //Column Chart
  Colors: string;
  DataSets: string;

  //Pagination
  offsetidx = 0;
  totalClosedDeal: number;
  currentPageNumber: number;
  totalPages: number;
  environment: number;
  /******************************* Variables ********************************/

  /******************************* Functions ********************************/
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private router: Router, private activateroute: ActivatedRoute, private TokenService: TokenService) {
    this.baseurl = environment.base_api;
    //Set param
    this.activateroute.params.subscribe(params => {
      this._ParamTeamCode = params['TeamCode'];
      this._ParamCurrentMonth = params['Month'];
      this._ParamCurrentYear = params['Year'];

    });
  }

  ngOnInit() {

    this._RoleCode = localStorage.getItem("EmpRoleCode");
    //this._RoleCode != "DIRECTOR" && this._RoleCode != "MANAGER"
    if (true) {
      this.router.navigate(['dashboardsale-detail']);
    } else
    {
      this.GlobalService.CheckPagingAccessRights();
    }

    var d = new Date();
    this.ListMonth = [
      "January", "February", "March", "April", "May", "June", "July",
      "August", "September", "October", "November", "December"
    ];
    for (var i = (d.getFullYear() - 15); i <= (d.getFullYear()); i++) {
      this.ListYear.push(i);
    }
    this.ListYear = this.ListYear.reverse();

    //Init ddl value
    //Init ddl value
    this.ddlMonth = !!this._ParamCurrentMonth ? this.ListMonth.indexOf(this._ParamCurrentMonth) + 1 : (d.getMonth() + 1).toString();
    this.ddlYear = !!this._ParamCurrentYear ? this._ParamCurrentYear : d.getFullYear().toString();

    this.CurrentYear = !!this._ParamCurrentYear ? Number(this._ParamCurrentYear) : d.getFullYear();
    this.CurrentMonth = !!this._ParamCurrentMonth ? this._ParamCurrentMonth : this.ListMonth[d.getMonth()];
    this.currentPageNumber = 1;

    //this.LoadListProjectCloseDealSummary();
    //this.OnLoadCountProjectCloseDealSummary();
    this.LoadAllProjectClosedDeal();
  }


  async LoadAllProjectClosedDeal() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var curDay = new Date();

      var d = new Date('01-' + this.CurrentMonth + this.CurrentYear);
      var days = new Date(curDay.getFullYear(), (curDay.getMonth() + 1), 0).getDate();
      var enddate = new Date(curDay.getFullYear() + '-' + (curDay.getMonth() + 1) + '-' + days);

      var d2 = new Date('01-' + this.CurrentMonth + this.CurrentYear)
      d2.setMonth(d2.getMonth() - 6);
      var startdays = new Date(d2.getFullYear(), (d2.getMonth() + 1), 0).getDate();
      var startdate = new Date(d2.getFullYear() + '-' + (d2.getMonth()+1) + '-' + startdays);


      var objectjson = {};
      objectjson['StartDate'] = startdate.toLocaleDateString('en-CA');
      objectjson['EndDate'] = enddate.toLocaleDateString('en-CA');


      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<SaleTeamInfo>(this.baseurl + "Dashboard/GetAllProjectClosedDeal",
          strjson, httpOptions)
        .subscribe({
          next: data => {
            this.SettingGoogleChartDataSetFormat(data);
          }
        });
    }

  }
  // async LoadListProjectCloseDealSummary() {
  //   var auth_token = await this.TokenService.RefreshToken();
  //   if (!!auth_token) {
  //     const httpOptions = {
  //       headers: new HttpHeaders({
  //         'Content-Type': 'application/json',
  //         'Authorization': `Bearer ${auth_token}`
  //       })
  //     };

  //     var d = new Date('01-' + this.CurrentMonth + this.CurrentYear)
  //     var days = new Date(this.CurrentYear, (d.getMonth() + 1), 0).getDate();
  //     var enddate = new Date(days + '-' + this.CurrentMonth + this.CurrentYear)



  //     let offset = (this.currentPageNumber - 1) * environment.PageSize;
  //     this.offsetidx = offset;
  //     var objectjson = {};
  //     objectjson['rowFetch'] = environment.PageSize;
  //     objectjson['rowOFFSet'] = offset;
  //     objectjson['StartDate'] = d.toLocaleDateString('en-CA');
  //     objectjson['EndDate'] = enddate.toLocaleDateString('en-CA');


  //     let strjson = JSON.stringify(objectjson);

  //     this.httpClient
  //       .post<SaleTeamInfo>(this.baseurl + "Dashboard/GetTeamSummaryList",
  //         strjson, httpOptions)
  //       .subscribe({
  //         next: data => {

  //           this.ListSaleTeamDetails = data.SaleTeamDetails;
  //           this.SaleTeams = data.SaleTeams;
  //           this.TotalBudget = data.TotalBudget;


  //           //Pie chart
  //           this.pieChartLabels = [];
  //           this.pieChartData = [];
  //           this.pieChartColors[0].backgroundColor = [];
  //           this.SaleTeams.forEach((traget, indextraget) => {
  //             this.pieChartLabels.push(traget.TeamName);
  //             this.pieChartData.push(traget.TeamTotalDeal);
  //             this.pieChartColors[0].backgroundColor.push(this.ListColor[indextraget])
  //           });

  //           //Team Rank
  //           var tmpList = this.SaleTeams.sort(function (a, b) {
  //             return a.TeamTotalDeal - b.TeamTotalDeal;
  //           });
  //           this.ListTeamRank = tmpList.reverse();
  //         }
  //       });
  //   }
  // }
  async LoadCountProjectCloseDealSummary() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var d = new Date('01-' + this.CurrentMonth + this.CurrentYear)
      var days = new Date(this.CurrentYear, (d.getMonth() + 1), 0).getDate();
      var enddate = new Date(days + '-' + this.CurrentMonth + this.CurrentYear)

      var objectjson = {};
      objectjson['StartDate'] = d.toLocaleDateString('en-CA');
      objectjson['EndDate'] = enddate.toLocaleDateString('en-CA');
      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<number>(this.baseurl + "Dashboard/GetCountTeamSummaryList",
          strjson, httpOptions)
        .toPromise();
    }
  }

  OnDdlMonthChange() {
    this.CurrentMonth = this.ListMonth[Number(this.ddlMonth) - 1];
    
    //this.LoadListProjectCloseDealSummary();
    //this.OnLoadCountProjectCloseDealSummary();
  }
  OnDdlYearChange() {
    this.CurrentYear = Number(this.ddlYear);

    //this.LoadListProjectCloseDealSummary();
    //this.OnLoadCountProjectCloseDealSummary();
  }
  OnTeamClick(TeamCode: string) {
    
    this.router.navigate(["/dashboardsale-detail", { TeamCode: TeamCode, Month: this.CurrentMonth, Year: this.CurrentYear }]);
  }

  //Pie Chart
  OnChartClicked(traget) {

  }

  //Column Chart
  SettingGoogleChartDataSetFormat(data: SaleTeamInfo) {
    var viewType = 1 ? "Month" : "Quarter"; //1 = Month or 2 = quarter
    var arrParent = [];
    var arrColors = [];
    //First row : defind chart labels
    if (data.SaleTeams.length > 0) {
      var tmp1stRowArr = [viewType];
      data.SaleTeams.forEach((traget, indextraget) => {
        tmp1stRowArr.push(traget.TeamName);
        arrColors.push(traget.TeamColor);
      });
      arrParent.push(tmp1stRowArr);
    }

    //Month
    var listMonthsNumber = [];
    for (var i = 0; i < 6; i++) {
      var d2 = new Date('01-' + this.CurrentMonth + '-' + this.CurrentYear);
      d2.setMonth(d2.getMonth() - i);
      listMonthsNumber.push(d2.toLocaleDateString('en-CA'));
    }
    listMonthsNumber = listMonthsNumber.reverse()

    //chart data sets
    
    var items = data.SaleTeamDetails;
    var that = this;
    listMonthsNumber.forEach((_date) => {
      var arrChild = [];
      var d = new Date(_date);
      var _dateEnd = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
      var _txtDateEnd = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + _dateEnd
      var fulteredDate = items.filter((x) => { return (new Date(x.ProjectSaleCloseDealCreateDate) >= new Date(_date) && new Date(x.ProjectSaleCloseDealCreateDate) <= new Date(_txtDateEnd)) })
      if (fulteredDate.length > 0) {
        arrChild.push((that.ListMonth[d.getMonth()]).substr(0, 3));
        data.SaleTeams.forEach((item) => {

          var projsOfTeam = fulteredDate.filter((x) => { return x.TeamCode == item.TeamCode });
          var sumProjPrice = projsOfTeam.reduce((accumulator, current) => accumulator + current.ProjectSaleActualPrice, 0);
          arrChild.push(sumProjPrice);

        });

        arrParent.push(arrChild);
      } else {
        arrChild.push((that.ListMonth[d.getMonth()]).substr(0, 3));
        data.SaleTeams.forEach((item) => {
          arrChild.push(0);
        });

        arrParent.push(arrChild);
      }
    });

    this.DataSets = JSON.stringify(arrParent);
    this.Colors = JSON.stringify(arrColors);
    
  }

  //Pagination
  OnLoadListFinished(traget = null) {

    if (traget != null) { // check call function from change page or onloadfrist
      this.currentPageNumber = traget.currentPageNumber;
      this.totalPages = traget.totalPages;
    }

    //this.LoadListProjectCloseDealSummary();
  }
  OnLoadCountProjectCloseDealSummary() {
    // this.LoadCountProjectCloseDealSummary().then(data => {
    //   this.totalClosedDeal = data;
    //   if(this.totalClosedDeal == 0) this.currentPageNumber = 0;
    //   this.totalPages = Math.ceil(this.totalClosedDeal / environment.PageSize);
    // });
  }

  
  /******************************* Functions ********************************/
}
